import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Checkbox, Modal, Row, Col } from 'antd';
import { useDispatch } from 'react-redux';

import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import PasswordField from '../../components/SharedComponents/FormComponents/PasswordField';
import EmailField from '../../components/SharedComponents/FormComponents/EmailField';

import { login } from '../../services/authApi/authApi';

import { toastNotify } from '../../utils/toastNotify';
import { addUserData } from '../../store/reducer/accountSlice';
import { AES } from 'crypto-js'
import { PasswordLoginField } from '../../components/SharedComponents/FormComponents/PasswordLoginField';

const ReLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoginButtonActive, setIsLoginButtonActive] = useState(true);

  const [openLoginModal] = useState(true);

  useEffect(() => {
    // let cookieToken = getCookie('tokenData');
    var input = document.getElementById('email');
    setTimeout(() => {
      if (input.matches(':-internal-autofill-selected')) {
        setIsLoginButtonActive(false);
        /* do something */
      }
    }, 500);
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const hashedPassword = AES.encrypt(values.password, process.env.REACT_APP_PASSWORD_ENCRYPT_KEY).toString();
      const userData = await login({ ...values, password: hashedPassword }, 'Web', rememberMe);
      if (!userData.isError) {
        await dispatch(addUserData({ userData: {}, isPinEntered: false }));
        localStorage.clear(); //clear localstorage
        const { accessToken, refreshToken = null, counter } = userData.data;
        await localStorage.setItem('access_token_temp', accessToken);
        refreshToken && (await localStorage.setItem('refresh_token', refreshToken));

        await localStorage.setItem('email', values.email);
        await localStorage.setItem('counter', counter);

        if (userData?.data?.isActive) {
          if (!userData.data.isEmailVerified) {
            navigate('/login', { replace: true });
            return;
          }
          if (!userData.data.isPinSet) {
            navigate('/login', { replace: true });
            return;
          }
          navigate('/login/enterpin', { replace: true });
        } else {
          navigate('/login', { replace: true });
        }
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {openLoginModal && (
        <Modal
          open={openLoginModal}
          width={524}
          closable={false}
          // closeIcon={<CloseIcon />}
          // onCancel={handleLoginModal}
          onCancel={() => false}
          footer={false}
          centered
          mask={false}
          maskClosable={false}
          keyboard={false}
        >
          <h4 className='text-center fz-24 fw-700 mb-16'>Log in</h4>
          <p className='mb-24 text-center'>Enter your credentials to access your account.</p>
          <Form name='login-form' className='details-form' autoComplete='off' onFinish={onFinish} form={form}>
            <FloatingLabel label='Email' name='email' inputValue={email}>
              <EmailField email={email} setEmail={(value) => setEmail(value)} />
            </FloatingLabel>
            <FloatingLabel label='Password' name='password' inputValue={password} className='mb-32'>
              <PasswordField name={'password'} setPassword={(value) => setPassword(value)} password={password} />
            </FloatingLabel>
            <Row className='mb-48'>
              <Col span={14}>
                <Form.Item>
                  <Checkbox onChange={(e) => setRememberMe(e.target.checked)}>Remember me for 30 days</Checkbox>
                </Form.Item>
              </Col>
              <Col span={10} className='text-right'>
                <Link to='/forgot-password/enter-email' replace className='underline fw-600 text-terracotta text-right'>
                  Forgot password
                </Link>
              </Col>
            </Row>
            <Form.Item shouldUpdate>
              {() => (
                <React.Fragment>
                  <Button
                    type='primary'
                    htmlType='submit'
                    className='ant-btn-primary--alt w-100'
                    loading={loading}
                    disabled={
                      (isLoginButtonActive && !form.isFieldsTouched(true)) || form.getFieldsError().filter(({ errors }) => errors.length).length > 0
                    }
                  >
                    Log in
                  </Button>
                </React.Fragment>
              )}
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};
export default ReLogin;
